export default function ArticleLinkSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
          Learn More
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-4">
          Deep Dive Into Sugargoo Spreadsheet
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
          Ready to master the art of finding the best products? Read our comprehensive guide covering everything from beginner tips to advanced search strategies.
        </p>
        <a
          href="/article/what-is-sugargoo-spreadsheet"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-base transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-article-line text-lg"></i>
          Read the Complete Guide
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}